class ProductSidebarAvoidance extends HTMLElement {
  #observer;
  #events;
  #panels = [];
  #tablet = window.matchMedia('(min-width: 701px) and (max-width: 1279px)');

  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    this.#tablet.addEventListener('change', this.#update, options);
    this.addEventListener('focusout', this.#afterFocus, options);
    // Section replacement can change the distant panel that this sidebar must avoid.
    document.addEventListener('shopify:section:load', this.#observe, options);
    document.addEventListener('shopify:section:unload', this.#afterSection, options);
    this.#observe();
  }

  disconnectedCallback() {
    this.#events?.abort();
    this.#observer?.disconnect();
    this.#panels = [];
    this.hidden = false;
  }

  #afterFocus = () => queueMicrotask(this.#update);
  #afterSection = () => queueMicrotask(this.#observe);

  #observe = () => {
    if (!this.isConnected) return;
    this.#observer?.disconnect();
    this.#panels = [...document.querySelectorAll('[data-product-tab-slider-01]')];
    // A zero-area boundary can count as intersecting before any panel pixels enter.
    this.#observer = new IntersectionObserver(this.#update, { threshold: [0, 0.001] });
    this.#panels.forEach((panel) => this.#observer.observe(panel));
    this.#update();
  };

  #update = () => {
    if (!this.isConnected) return;
    const avoidPanel = this.#tablet.matches && this.#panels.some((panel) => {
      const rect = panel.getBoundingClientRect();
      return panel.isConnected && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    });
    // Keep keyboard focus usable if navigation itself scrolls a panel into view.
    const keyboardFocusInside = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
    this.hidden = avoidPanel && !keyboardFocusInside;
  };
}

if (!customElements.get('product-sidebar-avoidance')) {
  customElements.define('product-sidebar-avoidance', ProductSidebarAvoidance);
}
